/* src/app/ai-sourcing/project-list-skeleton/project-list-skeleton.component.scss */
.skeleton-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.skeleton-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 12px;
}
.skeleton-row.header .skeleton-box {
  height: 18px;
  width: 40%;
}
.skeleton-box {
  height: 14px;
  border-radius: 4px;
  background:
    linear-gradient(
      90deg,
      #e0e0e0 25%,
      #f5f5f5 50%,
      #e0e0e0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}
@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
/*# sourceMappingURL=project-list-skeleton.component-STZ4S6ED.css.map */
